import { render } from "./AppendixSection.vue?vue&type=template&id=fda58674&scoped=true"
import script from "./AppendixSection.vue?vue&type=script&lang=js"
export * from "./AppendixSection.vue?vue&type=script&lang=js"

import "./AppendixSection.vue?vue&type=style&index=0&id=fda58674&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src710843524/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fda58674"]])

export default __exports__